import React, { useEffect, useMemo, useState } from "react";
import { getResearchStats } from "../../services/userPredictionService";
import { researchHubHtml } from "./researchHubHtml";
import "./ResearchHub.css";

/**
 * The research hub: how the AIs recorded here have done, from the public
 * record only.
 *
 * The page itself is researchHubHtml -- the same function public/seo.js calls
 * for the HTML crawlers receive -- so a visitor and a search engine read one
 * page, word for word. Everything in it is escaped where it is built.
 *
 * Renders nothing until the statistics arrive, and nothing if they cannot: the
 * listing below is the page's other half and stands on its own.
 */
const ResearchHub = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let live = true;
    getResearchStats()
      .then((s) => { if (live && s && s.totals) setStats(s); })
      .catch(() => {});
    return () => { live = false; };
  }, []);

  const html = useMemo(() => (stats ? researchHubHtml(stats) : ""), [stats]);

  // A link from the table of contents, or one shared with a #section, lands on
  // its section once the page has something to scroll to.
  useEffect(() => {
    if (!html || !window.location.hash) return;
    const target = document.getElementById(window.location.hash.slice(1));
    if (target) target.scrollIntoView();
  }, [html]);

  if (!html) return null;
  return <div className="mb-4" dangerouslySetInnerHTML={{ __html: html }} />;
};

export default ResearchHub;
